/**
 * 환경 변수 검증.
 * Vite는 import.meta.env로 주입하지만, 이 패키지는 앱/함수 양쪽에서
 * 재사용하므로 명시적으로 값을 주입한다.
 */

export interface FirebaseEnv {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  /** Realtime Database URL — presence/typing용 (PLAN 5-8장) */
  databaseURL?: string;
  /** VAPID 키 — Web Push 등록용 */
  vapidKey?: string;
}

const REQUIRED = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID',
] as const;

/** 에뮬레이터 사용 여부 (PLAN 12장 통합 테스트) */
export const USE_EMULATORS = false;

export function readEnv(source: Record<string, string | undefined>): FirebaseEnv {
  const missing = REQUIRED.filter((k) => !source[k]);
  if (missing.length > 0) {
    throw new Error(
      `Firebase 환경 변수가 없습니다: ${missing.join(', ')}\n` +
        '.env.local 을 생성하거나 .env.example 을 참고하세요.',
    );
  }

  return {
    apiKey: source.VITE_FIREBASE_API_KEY as string,
    authDomain: source.VITE_FIREBASE_AUTH_DOMAIN as string,
    projectId: source.VITE_FIREBASE_PROJECT_ID as string,
    storageBucket: source.VITE_FIREBASE_STORAGE_BUCKET as string,
    messagingSenderId: source.VITE_FIREBASE_MESSAGING_SENDER_ID as string,
    appId: source.VITE_FIREBASE_APP_ID as string,
    databaseURL: source.VITE_FIREBASE_DATABASE_URL,
    vapidKey: source.VITE_FIREBASE_VAPID_KEY,
  };
}
